var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Target") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Target",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,11 C9.6569,11 11,9.6569 11,8 C11,6.34315 9.6569,5 8,5 C6.34315,5 5,6.34315 5,8 C5,9.6569 6.34315,11 8,11 Z M8.5,0.5 C8.5,0.22386 8.2761,0 8,0 C7.72386,0 7.5,0.22386 7.5,0.5 L7.5,2.02054 C4.5851,2.26101 2.26101,4.5851 2.02054,7.5 L0.5,7.5 C0.22386,7.5 0,7.72386 0,8 C0,8.2761 0.22386,8.5 0.5,8.5 L2.02054,8.5 C2.26101,11.4149 4.5851,13.739 7.5,13.9795 L7.5,15.5 C7.5,15.7761 7.72386,16 8,16 C8.2761,16 8.5,15.7761 8.5,15.5 L8.5,13.9795 C11.4149,13.739 13.739,11.4149 13.9795,8.5 L15.5,8.5 C15.7761,8.5 16,8.2761 16,8 C16,7.72386 15.7761,7.5 15.5,7.5 L13.9795,7.5 C13.739,4.5851 11.4149,2.26101 8.5,2.02054 L8.5,0.5 Z M8,13 C5.23858,13 3,10.7614 3,8 C3,5.23858 5.23858,3 8,3 C10.7614,3 13,5.23858 13,8 C13,10.7614 10.7614,13 8,13 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/Target.3a3d932c.svg";
export { ForwardRef as ReactComponent };